import { useState } from "react";
import { Editor } from "@tiptap/react";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import Picker, { EmojiClickData } from "emoji-picker-react";
import { Popover, ToggleButton, SvgIcon } from "@mui/material";
import { styled } from "@mui/material/styles";

interface MenuButtonEmojiProps {
  editor: Editor;
  iconSize?: "small" | "inherit" | "large" | "medium";
}

const PlainIconButton = styled(ToggleButton)(({ theme }) => ({
  border: 0,
  background: "none",
  boxShadow: "none",
  minWidth: 0,
  padding: 4,
  borderRadius: 4,
  "&.Mui-selected": {
    background: "none",
    color: theme.palette.primary.main,
  },
  "&:hover": {
    background: "none",
    color: theme.palette.text.primary,
  },
}));

export function MenuButtonEmoji({ editor, iconSize = "small" }: MenuButtonEmojiProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEmojiClick = (emojiObject: EmojiClickData) => {
    editor.chain().focus().insertContent(emojiObject.emoji).run();
    handleClose();
  };

  return (
    <>
      <PlainIconButton value="emoji" onClick={handleOpen}>
        <SvgIcon fontSize={iconSize}>
          <EmojiEmotionsIcon />
        </SvgIcon>
      </PlainIconButton>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Picker onEmojiClick={handleEmojiClick} />
      </Popover>
    </>
  );
}
